import React from "react";

export default function CguPage() {
  return (
    <section className="mt-8 flex justify-center">
      <div className="lg:w-1/2 w-full p-4 lg:p-0">
        <h1 className="text-center text-3xl mb-8">
          Conditions Générales d'Utilisation de l'application "Influx"
        </h1>
        <h2 className="text-md font-bold">
          Article 1 : Objectifs et Fonctionnalités
        </h2>
        <p className="mb-4">
          L'application mobile "Influx" a pour but de mettre en relation les
          influenceurs et les entreprises dans le but de faire des partenariats.
          L'application comporte un système de swipe, de profil et de
          messagerie.
        </p>
        <h2 className="text-md font-bold">
          Article 2 : Inscription et accès au service
        </h2>
        <p className="mb-4">
          L’influenceur doit avoir au moins 18 ans pour accéder au site.
          <br />
          L’inscription au service se fait en créant un compte sur
          l’application. Lors de son inscription, l’utilisateur est invité à
          renseigner son profil pour avoir une expérience utilisateur la
          meilleure possible.
          <br />
          L’utilisation des services est soumise à la validation du compte
          utilisateur par la société. Cette dernière se réserve le droit de
          refuser l’accès à l'utilisateur ou d’en limiter l’utilisation.
          <br />
          Le service est fourni 24h/24 et 7j/7 hormis les périodes
          d’interruption nécessaires à la maintenance du service.
        </p>
        <h2 className="text-md font-bold">
          Article 3 : Protection des données personnelles
        </h2>
        <p className="mb-4">
          Les données personnelles collectées lors de l'utilisation de
          l'application sont utilisées exclusivement pour le bon fonctionnement
          du service. Elles ne seront ni vendues ni transmises à un tiers.
        </p>
        <h2 className="text-md font-bold">Article 4 : Mises à jour</h2>
        <p className="mb-4">
          Les mises à jour de l'application se font automatiquement via Google
          Play ou l'App Store.
        </p>
        <h2 className="text-md font-bold">Article 5 : Compte utilisateur</h2>
        <p className="mb-4">
          Un utilisateur peut voir son compte bloqué s'il enfreint les règles
          d'utilisation ou s'il est incorrect avec les autres utilisateurs,
          notamment via la messagerie.
        </p>
        <h2 className="text-md font-bold">
          Article 6 : Responsabilité de l'entreprise développeuse
        </h2>
        <p className="mb-4">
          L'entreprise développeuse s'engage à vérifier chaque profil présent
          sur l'application (vérification avec carte d'identité, etc.).
        </p>
        <h2 className="text-md font-bold">
          Article 7 : Propriété intellectuelle
        </h2>
        <p className="mb-4">
          Tous les contenus de l'application, y compris les textes, images,
          logos, graphismes, etc., sont protégés par les lois sur la propriété
          intellectuelle. Toute reproduction, utilisation ou distribution non
          autorisée peut entraîner des poursuites judiciaires.
        </p>
        <h2 className="text-md font-bold">
          Article 8 : Responsabilité de l'utilisateur
        </h2>
        <p className="mb-4">
          L'utilisateur est seul responsable de ses actions sur l'application,
          incluant les contenus publiés sur son profil et les communications
          avec d'autres utilisateurs. Il s'engage à respecter les lois et les
          droits des autres utilisateurs.
        </p>
        <h2 className="text-md font-bold">
          Article 9 : Clause de non-responsabilité
        </h2>
        <p className="mb-4">
          L'entreprise développeuse ne peut être tenue responsable pour tout
          dommage direct ou indirect découlant de l'utilisation de
          l'application.
        </p>
        <h2 className="text-md font-bold">
          Article 10 : Droit applicable – litiges
        </h2>
        <p className="mb-4">
          Les présentes CGU, ainsi que les relations avec la Société, sont
          régies, interprétées et appliquées conformément au droit français. En
          cas de litige survenant à l’occasion de l’interprétation ou de
          l’exécution du présent Contrat, les parties s’efforceront de le régler
          à l’amiable préalablement à toute action en justice.
          <br />
          Tous litiges liés à, ou découlant de, l’utilisation de l’Application
          ou du Service seront soumis à la compétence exclusive des juridictions
          du ressort de la Cour d’appel de Paris.
        </p>
        <p className="mb-4">
          En utilisant l'application "Influx", l'utilisateur accepte les
          Conditions Générales d'Utilisation telles qu'elles sont décrites
          ci-dessus. L'utilisateur reconnaît avoir pris connaissance de ces
          conditions et s'engage à les respecter. Tout manquement à ces
          conditions peut entraîner la suppression de son compte et des
          poursuites judiciaires.
          <br />
          Ces Conditions Générales d'Utilisation sont soumises au droit
          français. En cas de litige, les tribunaux français seront seuls
          compétents.
        </p>
      </div>
    </section>
  );
}
